
import React, { useState, useEffect } from 'react';
import { Container, Card, CardContent, TextField, Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import swal from 'sweetalert';
import { useTranslation } from "react-i18next";
import api from '../api/api';
import countryState from '../data/gistfile.json';
import { Button, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import PageTitle from '../components/common/PageTitle';
import '../admin/AdminManagement.css';

const AddSupplier = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [allCountry, setAllCountry] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [mobilePhone, setMobilePhone] = useState('');
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');

  const resetForm = () => {
    setName('');
    setEmail('');
    setAddress('');
    setMobilePhone('');
    setCountry('');
    setCity('');
  };

  const isValid = () => {
    return name && email && mobilePhone;
  };

  const addSupplier = () => {
    if (!isValid()) {
      swal({
        icon: 'error',
        title: t('error'),
        text: t('fill_required_fields'),
      });
      return;
    }

    let data = {
      name: name,
      address: address,
      tel_mobile: mobilePhone,
      city: city,
      country: country,
    };

    api.post('/supplier/add-supplier', data)
      .then(response => {
        if (response.data.type && response.data.type === 'success') {
          swal({
            icon: 'success',
            title: t('success'),
            text: t('supplier_added'),
          });
          resetForm();
        }
      })
      .catch(err => {
        console.error(err);
        swal({
          icon: 'error',
          title: t('error'),
          text: t('error_adding_supplier'),
        });
      });
  };

  useEffect(() => {
    let listcountry = [];
    countryState.countries.map((item, indx) => {
      listcountry.push(item.country);
    });
    setAllCountry(listcountry);
  }, []);

  const handleCountry = async (country) => {
    setCountry(country);
    let liststateSelectedCountry = [];
    allCountry.map((item, indx) => {
      if (item === country) {
        countryState.countries[indx].states.map((state, i) => {
          liststateSelectedCountry.push(state);
        });
      }
    });
    setAllStates(liststateSelectedCountry);
  };

  return (
    <>
      <Container maxWidth={false} className="admin-management-page">
        <Row noGutters className="admin-management-heading">
          <PageTitle subtitle={t('supplier_information')} md="12" className="text-sm-left" />
        </Row>
        <Card className="admin-data-card">
          <CardContent>
            <Row className='mt-2 gap-2'>
              <Col lg='6' md='12' sm='12'>
                <TextField
                  label={t('supplier_company_name')}
                  placeholder={t('supplier_company_name')}
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  size='small'
                  color="primary"
                  focused
                />
                <TextField
                  label={t('email')}
                  placeholder={t('email')}
                  fullWidth
                  type="email"
                  size='small'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className='my-3'
                  color="primary"
                  focused
                />
                <TextField
                  label={t('phone_number')}
                  placeholder={t('phone_number')}
                  fullWidth
                  size='small'
                  type="tel"
                  value={mobilePhone}
                  onChange={(e) => setMobilePhone(e.target.value)}
                  required
                  color="primary"
                  focused
                />
              </Col>
              <Col lg='5' md='12' sm='12'>
                <TextField
                  label={t('address')}
                  fullWidth
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  size='small'
                />
                <FormControl className='my-3' size='small' fullWidth>
                  <InputLabel htmlFor="country">{t('country')}</InputLabel>
                  <Select
                    value={country}
                    onChange={(e) => handleCountry(e.target.value)}
                    inputProps={{
                      name: 'country',
                      id: 'country',
                    }}
                  >
                    <MenuItem value="" disabled>{t('select_country')}</MenuItem>
                    {allCountry.map((country, i) => (
                      <MenuItem key={i} value={country}>{country}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size='small' fullWidth>
                  <InputLabel htmlFor="city">{t('city')}</InputLabel>
                  <Select
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    inputProps={{
                      name: 'city',
                      id: 'city',
                    }}
                  >
                    <MenuItem value="" disabled>{t('select_city')}</MenuItem>
                    {allStates.map((state, i) => (
                      <MenuItem key={i} value={state}>{state}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Col>
            </Row>
          </CardContent>
          <div className="admin-management-actions" style={{ justifyContent: 'flex-end', padding: '10px' }}>
            <Button variant="success" onClick={addSupplier}>
              {t('save')}
            </Button>
            <Button variant="outline-primary" onClick={() => navigate('/admin/users')}>
              {t('cancel')}
            </Button>
          </div>
        </Card>
      </Container>
    </>
  );
};

export default AddSupplier;